export default __webpack_public_path__ + "static/media/ct213-2.06cb5f80.png";